'use client';

var EBoxType;
(function (EBoxType) {
    EBoxType["primary"] = "primary";
    EBoxType["secondary"] = "secondary";
})(EBoxType || (EBoxType = {}));
var EOptionGroupType;
(function (EOptionGroupType) {
    EOptionGroupType["applyForm"] = "apply-popup-form";
    EOptionGroupType["other"] = "other";
})(EOptionGroupType || (EOptionGroupType = {}));

export { EBoxType, EOptionGroupType };
//# sourceMappingURL=type.js.map
